<template>
  <div class="item-wrapper">
    <div class="box" style="width: 350px; margin-right: 54px">
      <SummaryTitle title="공지사항 소개" :link="route.plaza1" />
      <div class="info-warpper">
        <NoticeCard
          title="k-웨이브 혁신공유대학 사전평가..."
          date="2023.09.13"
        />
      </div>
    </div>

    <div class="box" style="width: 396px; margin-right: 50px">
      <SummaryTitle title="보도자료" :link="route.plaza2" />
      <div class="info-warpper">
        <NewsCard
          title="K-컬처를 확장하는 글로벌 K-웨이브 교육과정"
          date="2023.09.13"
        />
      </div>
    </div>

    <div class="box" style="width: 350px">
      <img
        style="cursor: pointer"
        src="../../../assets/img/header/question.png"
        alt=""
        @click="menuRouter(route.plaza4)"
      />
    </div>
  </div>
</template>

<script>
import SummaryTitle from "@/components/molcules/header/SummaryTitle.vue";
import NoticeCard from "@/components/molcules/header/NoticeCard.vue";
import NewsCard from "@/components/molcules/header/NewsCard.vue";
import { route } from "@/router/route";
import { router } from "@/router";

export default {
  name: "SummaryBox5",
  components: { SummaryTitle, NoticeCard, NewsCard },
  data() {
    return { route };
  },
  methods: {
    menuRouter(link) {
      router.push({ path: link });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-warpper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}
</style>
